// src/utils/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 5000,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;

    // DEVICE_INVALID
    if (code === 'DEVICE_INVALID') {
      // 端末情報リセット
      localStorage.removeItem('device_uuid');

      // Dashboardへ戻す（ループ防止）
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }

      return Promise.reject(error);
    }
    // 認証切れ
    if (status === 401 && window.location.pathname !== '/login') {
      window.location.href = '/login';
      return new Promise(() => { });
    }

    // Not Found
    if (status === 404) {
      if (!window.location.pathname.startsWith('/not-found')) {
        window.location.replace('/not-found');
      }
      return Promise.reject(error);
    }

    // それ以外はそのまま投げる
    return Promise.reject(error);
  }
);

export default axiosInstance;
